import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <footer id="footer" className="custom-footer-section">
      <div className="container">
        <div className="row g-5">
          {/* BRAND COLUMN — logo + about + social together */}
          <div className="col-lg-4 col-md-12">
            <h2 className="custom-footer-logo">
              <img src={config?.logo} alt={config?.siteName || "Logo"} />
            </h2>
            <p className="custom-footer-about">
              Discover premium bicycles crafted for smooth performance, bold
              adventures, and effortless style. Curated for riders who value
              quality, comfort, and the thrill of every journey.
            </p>
            <ul className="custom-footer-social">
              {config?.socialMedia?.facebook && (
                <li>
                  <a
                    href={config.socialMedia.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <FaFacebook size={16} />
                  </a>
                </li>
              )}
              {config?.socialMedia?.instagram && (
                <li>
                  <a
                    href={config.socialMedia.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <FaInstagram size={16} />
                  </a>
                </li>
              )}
              {config?.socialMedia?.twitter && (
                <li>
                  <a
                    href={config.socialMedia.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <FaTwitter size={16} />
                  </a>
                </li>
              )}
              {config?.socialMedia?.youtube && (
                <li>
                  <a
                    href={config.socialMedia.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <FaYoutube size={16} />
                  </a>
                </li>
              )}
              {config?.socialMedia?.linkedin && (
                <li>
                  <a
                    href={config.socialMedia.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <FaLinkedin size={16} />
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* LINKS GROUP — teeno link columns ek row me, chhoti screen pe wrap honge */}
          <div className="col-lg-8 col-md-12">
            <div className="row g-4">
              <div className="col-6 col-md-4">
                <h4 className="custom-footer-heading">Quick Links</h4>
                <ul className="custom-footer-links">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/shop">Collections</Link>
                  </li>
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/blog">Blogs</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>

              <div className="col-6 col-md-4">
                <h4 className="custom-footer-heading">Useful Links</h4>
                <ul className="custom-footer-links">
                  <li>
                    <Link to="/privacy-policy">Privacy & Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/return-and-refund-policy">
                      Return and Refund Policy
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-6 col-md-4">
                <h4 className="custom-footer-heading">Categories</h4>
                <ul className="custom-footer-links">
                  {categories.map((cat) => (
                    <li key={cat._id}>
                      <Link to={`/categories/${cat.slugPath}`}>{cat.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="custom-footer-bottom">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="footer-tagline">
                All Rights Reserved &copy; 2026 Fast Rider
              </p>
            </div>

            <div className="col-md-6 text-center text-md-end">
              <a
                href="https://axesell.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-powered text-decoration-none"
              >
                <span>Designed & Developed By </span>

                <img
                  src={`${process.env.PUBLIC_URL}/images/axesell_logo.png`}
                  alt="Axesell"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
